import { Component, Inject, OnInit } from '@angular/core';
import { FormGroup, UntypedFormControl, UntypedFormGroup, Validators, FormsModule } from '@angular/forms';

import { ViewDetailsLoaderComponent } from '../view-details-loader/view-details-loader.component';
import { MatLegacyOption as MatOption, MatLegacyOptionModule as MatOptionModule } from '@angular/material/legacy-core';
import Swal from 'sweetalert2';

import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { DatePipe, NgIf, NgFor, NgClass } from '@angular/common';

import {
  MatLegacyDialogRef as MatDialogRef,
  MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
  MatLegacyDialog as MatDialog
} from '@angular/material/legacy-dialog';
import {
  MatLegacySelectChange as MatSelectChange,
  MatLegacySelectModule as MatSelectModule
} from '@angular/material/legacy-select';

import { statusManagerService } from '../../../app/services/status-manager.service';
import { LocalStorageService } from './../../connectors/localstorage';
import { UserBehaviorService } from './../../services/user-events/user-behavior.service';

import { HttpErrorResponse } from '@angular/common/http';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';
import { LoaderComponent } from '../../components/loader/loader.component';

@Component({
  selector: 'app-status-setup',
  templateUrl: './status-setup.component.html',
  styleUrls: ['./status-setup.component.css'],
  standalone: true,
  imports: [
    NgIf,
    LoaderComponent,
    NgFor,
    MatFormFieldModule,
    NgClass,
    MatInputModule,
    FormsModule,
    MatSelectModule,
    MatOptionModule,
    MatButtonModule
  ]
})
export class StatusSetupComponent implements OnInit {
  showLoader: boolean = true;

  step1FormGroup!: FormGroup;
  step1Done: boolean = true;
  requestedTypeSelected: any;
  requestedTypeSelectedOpt: any;
  formContent: StatusStructure[] = [];

  createdBy: string = 'Luiz Santos';
  creationDate: any = 'Dec 22, 2023';

  // TBD
  isColorsPermission: boolean = false;
  textColor: any[] = [];
  backgroundColor: any[] = [];
  textColorChild: any[] = [];
  backgroundColorChild: any[] = [];
  selectChoices: any[] = [];
  selectTeams: any[] = [];
  items: { statusName: string; id: string }[] = [];
  editAllow: boolean = false;
  nullFields: any[] = [];
  hasChanged: boolean = false;
  removeOptionName = 'Choose an option';
  btnSave: boolean = false;

  destroy$: Subject<boolean> = new Subject<boolean>();
  userName: any;
  currentDate = new Date().toLocaleString();

  modalClose = new Subject<boolean>();

  constructor(
    public dialogRef: MatDialogRef<StatusSetupComponent>,
    public dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private statusService: statusManagerService,
    private userBehavior: UserBehaviorService,
    private serviceLocalStorage: LocalStorageService,
    private datePipe: DatePipe
  ) {
    this.step1FormGroup = new UntypedFormGroup({
      statusName: new UntypedFormControl('', Validators.required),
      actionName: new UntypedFormControl(''),
      areaResponsible: new UntypedFormControl('opt-1', Validators.required),
      previousStatus: new UntypedFormControl(null),
      nextStatus: new UntypedFormControl(null),
      processEnd: new UntypedFormControl(null),
      requestorArea: new UntypedFormControl(null),
      multipleSelection: new UntypedFormControl(null),
      requireJustification: new UntypedFormControl(null),
      statusNameChild: new UntypedFormControl('', Validators.required),
      actionNameChild: new UntypedFormControl(''),
      comments: new UntypedFormControl(''),
      areaResponsibleChild: new UntypedFormControl('opt-3', Validators.required),
      previousStatusChild: new UntypedFormControl(null),
      nextStatusChild: new UntypedFormControl(null),
      processEndChild: new UntypedFormControl(null),
      requestorAreaChild: new UntypedFormControl(null),
      multipleSelectionChild: new UntypedFormControl(null),
      requireJustificationChild: new UntypedFormControl(null)
    });
    this.modalClose = new Subject<boolean>();
  }

  ngOnInit(): void {
    this.getTeams();
    this.getStatus();

    this.userBehavior.selectedUser.pipe(takeUntil(this.destroy$)).subscribe((value: any) => {
      this.userName = value.name;
    });
  }

  getStatus() {
    this.statusService
      .getStatus(this.data.reqId)
      .pipe(takeUntil(this.destroy$))
      .subscribe((status: any) => {
        if (status.length > 0) {
          this.formContent = status;
          this.extractStatusNames(status, false);
          this.editAllow = true;
        } else {
          this.inputsFormating();
          this.editAllow = false;
        }
        setTimeout(() => {
          this.showLoader = false;
        }, 50);
      });
  }
  getTeams() {
    this.statusService
      .getTeams()
      .pipe(takeUntil(this.destroy$))
      .subscribe((teams: any) => {
        this.selectTeams = teams;
      });
  }

  getUserId() {
    return Number(this.serviceLocalStorage.decryptAndGet('userId'));
  }

  getCurrentDate(): string | null {
    const formattedDate = this.datePipe.transform(new Date(), 'yyyy-MM-ddTHH:mm:ss.SSSZ');

    return formattedDate;
  }

  //TODO: When the status is a child you need to add the boolean true
  extractStatusNames(data: any[], child: any) {
    for (const [index, item] of data.entries()) {
      if (!this.selectChoices.includes(item.statusName)) {
        this.selectChoices.push({
          index,
          statusName: item.statusName,
          child,
          statusId: item.statusId
        });
      }

      if (item.child && item.child.length > 0) {
        this.extractStatusNames(item.child, true);
      }
    }
  }

  // Reactive Forms
  get getStep1() {
    return this.step1FormGroup.controls;
  }

  activeEditStatus() {
    this.editAllow = false;
  }

  // Inputs Formating
  inputsFormating() {
    const draftObj = {
      statusId: 0,
      seq: 0,
      statusName: 'Draft',
      requestId: this.data.reqId,
      teamRespId: 0,
      teamRespName: null,
      previousStatusId: null,
      nextStatusId: null,
      previousStatusName: null,
      nextStatusName: null,
      actionName: 'Draft',
      comments: null,
      creationDate: this.getCurrentDate() as string,
      createdById: this.data.userId,
      createdByName: null,
      updateDate: null,
      updatedBy: null,
      updateByName: null,
      multipleSelecFlag: false,
      requestorAreaFlag: true,
      processEndFlag: false,
      justificationFlag: false,
      statusFlag: null,
      child: []
    };
    let index = 0;
    let child = false;
    this.selectChoices.push({ index, statusName: 'Draft', child });
    this.formContent.push(draftObj);
  }

  // Selection Change
  onSelectionChange(event: MatSelectChange, prev: boolean, status: any) {
    const selectedOption = event.source.selected as MatOption;

    if (selectedOption?.value === undefined) {
      if (prev) {
        status.previousStatusName = null;
        status.previousStatusId = null;
      } else {
        status.nextStatusName = null;
        status.nextStatusId = null;
      }
    } else {
      this.requestedTypeSelected = selectedOption.viewValue;
      this.requestedTypeSelectedOpt = selectedOption.value;
      if (prev) {
        status.previousStatusName = selectedOption.viewValue;
        status.previousStatusId = selectedOption.value;
      } else {
        status.nextStatusName = selectedOption.viewValue;
        status.nextStatusId = selectedOption.value;
      }
    }
  }

  selectMulti(status: any) {
    status.nextStatusName = null;
    status.nextStatusId = null;
  }

  selectProcessEnd(status: any) {
    status.nextStatusName = null;
    status.nextStatusId = null;
  }

  onSelectionChangeArea(event: MatSelectChange, parent: any) {
    const selectedOption = event.source.selected as MatOption;

    if (selectedOption?.value === undefined) {
      parent.teamRespId = null;
      parent.teamRespName = null;
    } else {
      parent.teamRespName = selectedOption.viewValue;
      parent.teamRespId = selectedOption.value;
      parent.requestorAreaFlag = false;
    }
  }

  selectRequestArea(status: any) {
    status.teamRespName = null;
    status.teamRespId = null;
  }

  // Form Validate
  onSubmit(actualForm: any) {
    if (actualForm.invalid) {
      return;
    } else {
      this.step1Done = true;
    }
  }

  // Add Parent
  addParent(index: any) {
    const newRow = {
      statusId: 0,
      seq: this.formContent.length,
      statusName: null,
      requestId: this.data?.reqId,
      teamRespId: 0,
      previousStatusId: null,
      teamRespName: null,
      nextStatusId: null,
      previousStatusName: null,
      nextStatusName: null,
      actionName: null,
      comments: null,
      creationDate: this.getCurrentDate() as string,
      createdById: this.data.userId,
      createdByName: null,
      updateDate: null,
      updatedBy: null,
      updateByName: null,
      multipleSelecFlag: false,
      requestorAreaFlag: false,
      processEndFlag: false,
      justificationFlag: false,
      statusFlag: null
    };

    this.formContent.splice(index + 1, 0, newRow);
  }

  // Remove Line
  removeLine(value: string, index: number, isChild: boolean, event: any) {
    if (index >= 0 && index < this.formContent.length) {
      this.formContent.splice(index, 1);

      this.selectChoices = [];

      this.formContent.map((item) => {
        this.selectChoices.push({
          index,
          statusName: item.statusName,
          isChild: isChild,
          statusId: item.statusId
        });
      });
    }
    this.addOption('', index, isChild, event);
  }

  // Close Modal
  closeDialog() {
    if (!this.hasChanged) {
      this.step1FormGroup.reset();
      this.dialogRef.close(this.hasChanged);
    } else {
      Swal.fire({
        title: 'Are you sure\nyou want to cancel?',
        html: '- all changes will be lost -',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, continue',
        cancelButtonText: 'NO, cancel it!',
        reverseButtons: false,
        focusDeny: true,
        width: '',
        customClass: {
          container: 'confirm-modal',
          title: 'confirm-title'
        }
      }).then((result) => {
        if (result.isConfirmed) {
          this.step1FormGroup.reset();
          this.dialogRef.close(!this.hasChanged);
        }
      });
    }
  }

  savedClose() {
    this.step1FormGroup.reset();
    this.dialogRef.close(true);
  }

  // Next Step Return
  nextStep() {
    const Toast = Swal.mixin({
      toast: true,
      position: 'top-end',
      iconColor: 'white',
      customClass: {
        popup: 'colored-toast'
      },
      showConfirmButton: false,
      timer: 3000,
      timerProgressBar: true,
      showCloseButton: true
    });
    (async () => {
      await Toast.fire({
        icon: 'success',
        title: 'Success',
        html: 'Your changes have been saved.'
      });
      await Toast.fire({
        icon: 'error',
        title: 'Error',
        html: 'Your changes could not be saved, please try again later.'
      });
    })();
  }

  save() {
    this.btnSave = true;
    this.checkNullFields();
  }

  // Save Form
  saveForm(success: boolean) {
    if (success) {
      Swal.fire({
        title: 'Saved!',
        html: '',
        icon: 'success',
        confirmButtonColor: '#3085d6'
      }).then((result) => {
        if (result.isConfirmed) {
        }
      });
    } else if (!success) {
      Swal.fire({
        title: 'Error',
        html: 'Changes are not saved!',
        icon: 'error',
        confirmButtonColor: '#3085d6'
      }).then((result) => {
        if (result.isConfirmed) {
        }
      });
    }
  }

  addOption(value: string, index: number, isChild: boolean, event: any): void {
    if (value.trim() !== '') {
      const existingItem = this.selectChoices.find((item) => item?.index === index);

      if (existingItem) {
        existingItem.statusName = value;
      }
      this.normalize();
    } else {
      this.removeOption(index, isChild);
    }
  }

  normalize() {
    this.selectChoices = [];
    for (let index = 0; index < this.formContent.length; index++) {
      this.selectChoices.push({
        index: index + 1,
        statusName: this.formContent[index].statusName,
        isChild: false,
        statusId: this.formContent[index].statusId
      });
    }
  }

  removeOption(index: number, isChild: boolean): void {
    this.selectChoices = this.selectChoices.filter((item) => item.index !== index + 1);
  }

  async checkNullFields() {
    let count = 0;
    this.nullFields = [];
    const totalRows = this.formContent.length;

    for (let i = 0; i < totalRows; i++) {
      const status = this.formContent[i];

      this.checkFieldAndAddNullMessage('Status Name', status.statusName);
      status.seq = count;
      count += 1;

      if (!status.requestorAreaFlag) {
        this.checkFieldAndAddNullMessage('Area Resp reponsible', status.teamRespName, false);
      }

      if (status.processEndFlag || status.multipleSelecFlag) {
        this.checkFieldAndAddNullMessage('Child Next Status', status.nextStatusName, true);
      } else {
        this.checkFieldAndAddNullMessage('Child Next Status', status.nextStatusName, false);
      }

      // Check if it's the last row, and allow null for nextStatusName
      if (status.statusName !== 'Draft') {
        this.checkFieldAndAddNullMessage('Previous Status', status.previousStatusName, false);
      }
    }

    //create status
    if (this.nullFields.length === 0 && !this.formContent[0].statusId) {
      await this.openProgressDialog('Loading...');
      this.statusService.saveStatusFlow(this.formContent).subscribe({
        next: () => {
          this.btnSave = false;
          this.closeModal();
          this.swalModalMessage(true);
        },
        error: (error) => {
          this.closeModal();
          this.handleError(error);
        }
      });

      //update status
    } else if (this.nullFields.length === 0 && !this.editAllow && this.formContent[0].statusId) {
      const formattedDate = this.getCurrentDate();

      this.formContent.forEach((item) => {
        (item.updateDate = formattedDate ? formattedDate : ''), (item.updatedBy = this.getUserId());
      });
      await this.openProgressDialog('Loading...');
      this.statusService.updateStatus(this.formContent).subscribe({
        next: () => {
          this.btnSave = false;
          this.closeModal();
          this.swalModalMessage(true);
        },
        error: (error) => {
          this.closeModal();
          this.handleError(error);
        }
      });
    } else {
      this.btnSave = false;
      this.swalModalMessage(false);
    }
  }

  private checkFieldAndAddNullMessage(fieldName: string, fieldValue: string | null, allowEmpty: boolean = true): void {
    if (
      (!allowEmpty && fieldValue === null) ||
      (allowEmpty && fieldValue !== null && fieldValue.trim() === '' && !this.fieldAlreadyExists(fieldName))
    ) {
      const message = `${fieldName} is required`;
      this.nullFields.push({ [fieldName]: message });
    }
  }

  private fieldAlreadyExists(fieldName: string): boolean {
    return this.nullFields.some((field) => Object.keys(field)[0] === fieldName);
  }

  isFieldEmpty(fieldValue: string | null): boolean {
    return fieldValue === null || fieldValue.trim() === '';
  }

  // ngOnDestroy(): void {
  //   this.destroy$.next();
  //   this.destroy$?.complete();
  // }

  handleError(error: HttpErrorResponse): void {
    if (error.status === 409 || error.status === 406) {
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: error.error.message,
        footer:
          '<a href="mailto:AM.US.OM.BusinessSolutions@global.ntt?Subject=Help!" class="btn-support">click here to contact the support</a>',
        confirmButtonColor: '#3085D6',
        showClass: {
          popup: 'error-swal'
        }
      }).then((result) => {
        this.getStatus();
        if (result.isConfirmed) {
          this.getStatus();
        }
      });

      return;
    }

    Swal.fire({
      icon: 'error',
      title: 'Error',
      text: 'Something went wrong! Please, try again in a moment.',
      footer:
        '<a href="mailto:AM.US.OM.BusinessSolutions@global.ntt?Subject=Help!" class="btn-support">click here to contact the support</a>',
      confirmButtonColor: '#3085D6',
      showClass: {
        popup: 'error-swal'
      }
    }).then((result) => {
      this.getStatus();
    });
  }

  swalModalMessage(actionCompleted: boolean) {
    if (actionCompleted) {
      Swal.fire({
        icon: 'success',
        title: 'Success',
        text: 'Your informations has been saved!',
        confirmButtonColor: '#3085D6',
        showClass: {
          popup: 'success-swal'
        }
      }).then((result) => {
        this.savedClose();
      });
    } else {
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'There are mandatory fields that require attention.',
        footer:
          '<a href="mailto:AM.US.OM.BusinessSolutions@global.ntt?Subject=Help!" class="btn-support">click here to contact the support</a>',
        confirmButtonColor: '#3085D6',
        showClass: {
          popup: 'error-swal'
        }
      });
    }
  }

  closeModal() {
    this.modalClose.next(true);
  }

  openProgressDialog(text: any): Promise<void> {
    return new Promise((resolve) => {
      const dialogRef = this.dialog.open(ViewDetailsLoaderComponent, {
        autoFocus: false,
        closeOnNavigation: true,
        disableClose: true,
        height: '250px',
        width: '600px',
        panelClass: 'center-modal',
        data: { modalClose$: this.modalClose, text: text }
      });
      dialogRef.afterOpened().subscribe(() => {
        setTimeout(() => {
          resolve();
        }, 500);
      });
    });
  }
}

interface StatusStructure {
  statusId: number;
  seq: number;
  statusName: string | null;
  requestId: number;
  teamRespId: number;
  teamRespName: string | null;
  previousStatusId: null;
  nextStatusId: null;
  previousStatusName: string | null;
  nextStatusName: string | null;
  actionName: string | null;
  comments: string | null;
  creationDate: string;
  createdById: number;
  createdByName: string | null;
  updateDate: string | null;
  updatedBy: number | null;
  updateByName: string | null;
  multipleSelecFlag: boolean;
  requestorAreaFlag: boolean;
  processEndFlag: boolean;
  justificationFlag: boolean;
  statusFlag: string | null;
}
